import { Component, State,  Event, EventEmitter, Watch, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'jump-pagination-table',
  styleUrl: 'jump-pagination-table.scss',
  shadow: false,
})
export class JumpPaginationTable {

  /* ---------------------- OWN PROPERTIES ---------------------- */

  /* ---------------------- @ELEMENT ---------------------------- */

  /* ---------------------- @STATE ------------------------------ */

  /* ---------------------- @PROPERTIES ------------------------- */

  /**
   * Values for the elements per page select
   */
  @Prop() elementsRanges: string = "10,20,60,100";

  @State() elementsRangesArray: number[];
  @Watch('elementsRanges')
  elementsRangesChanged(newValue, oldValue) {
    console.log('dentro el');
    if(newValue !== oldValue) {
      this.elementsRangesArray = newValue.split(',').map(Number);
      }
    this.elementsRangesArray = [...this.elementsRangesArray]
    console.log('elementsRangesChanged', newValue, oldValue);
  }

  /**
   * Number of elements per page selected
   */
  @Prop() elPerPage: number;
  @Watch('elPerPage')
  elPerPageChanged(newValue: number, oldValue: number) {
    if (newValue !== oldValue) {
      // Riporta la paginazione allo stato iniziale
      this.first = 1;
      this.last = Math.min(this.total, newValue);
    }

    this.changeElPerPage.emit({ elPerPage: newValue });
  }

  @Prop({ reflect: true }) pagLabel: string = 'di'; // Identifica la label testuale di pagination.

  /**
   * Label for the elements per page select
   */
  @Prop({ reflect: true }) labelElementsPerPage: string = 'Elementi per pagina';

  /**
   * Total of elements
   */
  @Prop({ reflect: true }) total: number = 100;

  /**
   * First element of the page
   */
  @Prop({ reflect: true }) first: number = 1;

  /**
   * Last element of the page
   */
  @Prop({ reflect: true }) last: number = 10;

  /**
   * Show button to navigate so first e last page
   */
  @Prop({ reflect: true }) showFirstAndLast: boolean = false;

  /* ---------------------- @EVENTS ------------------------- */
  @Event({ eventName: 'jump-change-page' }) changePage: EventEmitter;
  @Event({ eventName: 'jump-change-el-per-page' }) changeElPerPage: EventEmitter;

  /* -------------------- LYFECYCLE EVENTS ---------------------- */
  componentWillLoad() {
    this.elementsRangesArray = this.elementsRanges.split(',').map(Number);
    this.elPerPage = !this.elPerPage ? this.elementsRangesArray[0] : this.elPerPage;
  }

  /* -------------------- @LISTEN ------------------------------- */

  /* -------------------- @METHOD ------------------------------- */

  /* -------------------- LOCAL METHODS ------------------------- */
  setElPerPage(e) {
    this.elPerPage = e.target.value;
  }

  doChangePage(dir) {
    let newFirst;
    let newLast;

    //TODO refactorare
    if (dir === 'first') {
      newFirst = 1;
      newLast = Math.min(this.total, this.elPerPage);
    } else if (dir === 'last') {
      newLast = this.total;
      newFirst = Math.max(1, this.total - this.elPerPage + 1);
    } else if (dir === 'previous') {
      newFirst = Math.max(1, this.first - this.elPerPage);
      newLast = Math.min(this.total, newFirst + this.elPerPage - 1);
    } else if (dir === 'next') {
      newLast = Math.min(this.total, this.last + this.elPerPage);
      newFirst = Math.max(1, newLast - this.elPerPage + 1);
    }

    this.first = newFirst;
    this.last = newLast;

    let details = {
      first: newFirst,
      last: newLast,
      direction: dir
    }

    this.changePage.emit(details);
  }

  /* --------------------- RENDER ------------------------------- */
  render() {
    return (
      <Host class="JumpPaginationTable">
        <div class="JumpPaginationTable__Wrapper">
          <div class="elementsPerPage">
            <label htmlFor="elements">{this.labelElementsPerPage ?? 'Elements per page'}</label>
            <select name="elements" id="elements" onChange={(e) => this.setElPerPage(e)}>
              {this.elementsRangesArray.map((range) => (
                <option value={range} selected={(this.elPerPage == range) && true}>{range}</option>
              ))}
            </select>
          </div>
          <div class="indicators">
            <div class="elements">
              <span>
                <span>{this.first}</span> - <span>{this.last}</span> {this.pagLabel} <span>{this.total}</span>
              </span>
            </div>
            <div class="arrow">
              {this.showFirstAndLast &&
                <jump-button onClick={() => this.doChangePage('first')} variant="primary" text size="small" name="scopri" value="value" aria-label="Scopri di più" id="button" onlyIcon disabled={this.first === 1}> <jump-icon slot="suffix" name="chevrons-left" ></jump-icon> </jump-button>
              }
              <jump-button onClick={() => this.doChangePage('previous')} variant="primary" text size="small" name="scopri" value="value" aria-label="Scopri di più" id="button" onlyIcon disabled={this.first === 1}> <jump-icon slot="suffix" name="chevron-left" ></jump-icon> </jump-button>
              <jump-button onClick={() => this.doChangePage('next')} variant="primary" text size="small" name="scopri" value="value" aria-label="Scopri di più" id="button" onlyIcon disabled={this.last === this.total}> <jump-icon slot="suffix" name="chevron-right" ></jump-icon> </jump-button>
              {this.showFirstAndLast &&
                <jump-button onClick={() => this.doChangePage('last')} variant="primary" text size="small" name="scopri" value="value" aria-label="Scopri di più" id="button" onlyIcon disabled={this.last === this.total}> <jump-icon slot="suffix" name="chevrons-right" ></jump-icon> </jump-button>
              }
            </div>
          </div>
        </div>
      </Host>
    );
  }

}
